var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--complete",attrs:{"disabled":_vm.disabled,"type":_vm.type,"data-cy":_vm.commonCy.SINGLE_ORDER.MANAGE_ORDER.BUTTON__SCHEDULE_FOR_DELIVERY},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" Schedule for Delivery ")])
}
var staticRenderFns = []

export { render, staticRenderFns }